var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GoogleMap } from '@capacitor/google-maps';
import { useRef, useLayoutEffect, useCallback, memo, useState, useEffect, } from 'react';
function useGoogleMap(ref) {
    var _this = this;
    var _a = useState(0), longitude = _a[0], setLongitude = _a[1];
    var _b = useState(0), latitude = _b[0], setLatitude = _b[1];
    var _c = useState(), address = _c[0], setAddress = _c[1];
    var _d = useState(false), markerChanged = _d[0], setMarkerChanged = _d[1];
    var getAddress = useCallback(function () {
        fetch("https://maps.googleapis.com/maps/api/geocode/json?latlng=\n        ".concat(latitude, ",").concat(longitude, "&key=").concat(process.env.REACT_APP_MAP_API_KEY))
            .then(function (response) { return response.json(); })
            .then(function (data) {
            var _a;
            if (data.results.length) {
                setAddress((_a = data.results.find(function (result) {
                    return result.address_components.find(function (address) {
                        return address.types.find(function (type) {
                            return type.includes('street_number') || type.includes('route');
                        });
                    });
                })) === null || _a === void 0 ? void 0 : _a.address_components);
            }
        });
    }, [latitude, longitude]);
    var initMaps = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var map, markerId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, GoogleMap.create({
                        id: 'google-map',
                        element: ref.current,
                        apiKey: process.env.REACT_APP_MAP_API_KEY || '',
                        config: {
                            center: {
                                lat: latitude,
                                lng: longitude,
                            },
                            zoom: 15,
                            disableDefaultUI: true,
                        },
                    })];
                case 1:
                    map = _a.sent();
                    return [4, map.addMarker({
                            coordinate: {
                                lat: latitude,
                                lng: longitude,
                            },
                            draggable: true,
                        })];
                case 2:
                    markerId = _a.sent();
                    return [4, map.setOnMarkerDragEndListener(function (event) {
                            setMarkerChanged(true);
                            setLongitude(event === null || event === void 0 ? void 0 : event.longitude);
                            setLatitude(event === null || event === void 0 ? void 0 : event.latitude);
                        })];
                case 3:
                    _a.sent();
                    if (!markerChanged) return [3, 5];
                    map.removeMarker(markerId);
                    return [4, map.addMarker({
                            coordinate: {
                                lat: latitude,
                                lng: longitude,
                            },
                            draggable: true,
                        })];
                case 4:
                    _a.sent();
                    setMarkerChanged(false);
                    getAddress();
                    _a.label = 5;
                case 5: return [2];
            }
        });
    }); }, [markerChanged, getAddress, latitude, longitude, ref]);
    useLayoutEffect(function () {
        navigator.geolocation.getCurrentPosition(function (_a) {
            var coords = _a.coords;
            if (coords === null || coords === void 0 ? void 0 : coords.longitude) {
                setLongitude(coords === null || coords === void 0 ? void 0 : coords.longitude);
            }
            if (coords === null || coords === void 0 ? void 0 : coords.latitude) {
                setLatitude(coords === null || coords === void 0 ? void 0 : coords.latitude);
            }
        });
    }, []);
    useLayoutEffect(function () {
        initMaps();
    }, [initMaps]);
    useEffect(function () {
        if (!address) {
            getAddress();
        }
    }, [address, getAddress]);
    return {
        address: address,
        coords: {
            latitude: latitude,
            longitude: longitude,
        },
        setLatitude: setLatitude,
        setLongitude: setLongitude,
    };
}
function CustomGoogleMapComponent(props) {
    var mapRef = useRef();
    var address = useGoogleMap(mapRef).address;
    useEffect(function () {
        if (props.onChange) {
            props.onChange(address);
        }
    }, [address, props]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "component-wrapper" }, { children: _jsx("capacitor-google-map", { ref: mapRef, style: {
                        display: 'inline-block',
                        width: window.screen.width,
                        height: props.height || window.screen.height / 2,
                    } }) })), props.children] }));
}
export var CustomGoogleMap = memo(CustomGoogleMapComponent);
//# sourceMappingURL=index.js.map